@if (messages?.length) {
  <div class="mt-3 flex flex-column gap-2">
    @for (msg of messages; track msg) {
      <p-message severity="info"
                 icon="pi pi-info-circle">
        {{ msg }}
      </p-message>
    }
  </div>
} @else {
  <div class="mt-3">
    <p-message severity="info"
               icon="pi pi-info-circle"
               class="field">{{ message }}</p-message>
  </div>
}